import { MultiSelect } from '@mantine/core';

import classes from './multiselect.module.css';

export const MultiSelectOverride = MultiSelect.extend({ classNames: classes });
